import React from 'react';
import { VStack, Box } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
import { usePreviewNavigation } from '../hooks/useModulePreviewStore';
import { Layout, BookOpen, FileText, GitCompare } from 'lucide-react-native';
import NavButton from '../../../navigation/components/NavButton';

/**
 * Navigation component for the preview interface
 * Provides buttons to switch between course, module, task, and diff views in a vertical sidebar layout
 */
const ModulePreviewNavigation = () => {
  const { t } = useTranslation();
  const {
    activeView,
    setActiveView,
    canViewTask,
    canViewDiff
  } = usePreviewNavigation();

  return (
    <Box
      bg="$backgroundLight0"
      width={72}
      height="100%"
      borderRightWidth={1}
      borderRightColor="$borderLight200"
    >
      <VStack
        space="lg"
        alignItems="center"
        py={28}
      >
        <NavButton
          icon={Layout}
          active={activeView === 'course'}
          onPress={() => setActiveView('course')}
        />

        <NavButton
          icon={BookOpen}
          active={activeView === 'module'}
          onPress={() => setActiveView('module')}
        />

        <NavButton
          icon={FileText}
          active={activeView === 'task'}
          onPress={() => setActiveView('task')}
          isDisabled={!canViewTask}
        />

        <NavButton
          icon={GitCompare}
          active={activeView === 'diff'}
          onPress={() => setActiveView('diff')}
          isDisabled={!canViewDiff}
        />
      </VStack>
    </Box>
  );
};

export default ModulePreviewNavigation;